/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ReferralSubmissionResponse } from './';
import {
    ReferralSubmissionResponseFromJSON,
    ReferralSubmissionResponseFromJSONTyped,
    ReferralSubmissionResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchReferralSubmissionResponse
 */
export interface SearchReferralSubmissionResponse {
    /**
     * The total number of submission requests
     * @type {number}
     * @memberof SearchReferralSubmissionResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ReferralSubmissionResponse>}
     * @memberof SearchReferralSubmissionResponse
     */
    items: Array<ReferralSubmissionResponse>;
}

/**
 * Check if a given object implements the SearchReferralSubmissionResponse interface.
 */
export function instanceOfSearchReferralSubmissionResponse(value: object): value is SearchReferralSubmissionResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function SearchReferralSubmissionResponseFromJSON(json: any): SearchReferralSubmissionResponse {
    return SearchReferralSubmissionResponseFromJSONTyped(json, false);
}

export function SearchReferralSubmissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchReferralSubmissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'items': ((json['items'] as Array<any>).map(ReferralSubmissionResponseFromJSON)),
    };
}

export function SearchReferralSubmissionResponseToJSON(value?: SearchReferralSubmissionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'items': ((value['items'] as Array<any>).map((v) => ReferralSubmissionResponseToJSON(v))),
    };
}

